// extracted by mini-css-extract-plugin
module.exports = {"title":"title_title__sOofZ","wrapper":"title_wrapper__ZJcnE","hide":"title_hide__mfECl"};